<template>
  <div>
    <!-- ====================================================================================================================== -->
    <v-sheet class="c-block-1">
      <v-row>
        <v-col cols="12">
          <RateFilter @handleFilter="handleFilter" :role="'7'" />
        </v-col>
      </v-row>
    </v-sheet>
    <br />
    <!-- ====================================================================================================================== -->
    <v-row>
      <v-col cols="3">
        <v-sheet class="c-block-1" style="margin-bottom: 11px; display: flex; justify-content: space-between;">
          <h4>  المكالمات </h4>
          <div class="back-txt" style="padding-left: 0;" @click="backToAgentPercentage">
            عودة
            <span>
              <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd" d="M20 17.418C17.5535 14.4315 15.381 12.737 13.482 12.334C11.5835 11.9315 9.776 11.8705 8.059 12.1515V17.5L0 8.7725L8.059 0.5V5.5835C11.2335 5.6085 13.932 6.7475 16.155 9C18.3775 11.2525 19.6595 14.0585 20 17.418Z" fill="#3F0E40"/>
              </svg>
            </span>
          </div>
        </v-sheet>
        <v-sheet class="c-block-1 auc-card2 call-center-summary">
          <div class="call-stats-grid">
            <div class="call-stat-box incoming">
              <v-icon size="22" color="#1565C0">mdi-phone-incoming</v-icon>
              <span class="call-stat-num">{{ formatCount(incoming_count) }}</span>
              <span class="call-stat-lbl">واردة</span>
            </div>
            <div class="call-stat-box outgoing">
              <v-icon size="22" color="#7E1280">mdi-phone-outgoing</v-icon>
              <span class="call-stat-num">{{ formatCount(outgoing_count) }}</span>
              <span class="call-stat-lbl">صادرة</span>
            </div>
            <div class="call-stat-box unknown">
              <v-icon size="22" color="#c05415">mdi-phone-unknown</v-icon>
              <span class="call-stat-num">{{ formatCount(unknown_count) }}</span>
              <span class="call-stat-lbl">غير معروف</span>
            </div>
            <div class="call-stat-box total">
              <span class="call-stat-num-lg">{{ formatCount(total_count) }}</span>
              <span class="call-stat-lbl">الإجمالي</span>
            </div>
            
          </div>
          <div class="call-ratio-bar" v-if="total_count > 0">
            <div class="call-ratio-seg incoming-seg" :style="{ width: incoming_percent + '%' }"></div>
            <div class="call-ratio-seg outgoing-seg" :style="{ width: outgoing_percent + '%' }"></div>
          </div>
        </v-sheet>
      </v-col>
      <v-col cols="9">
        <v-sheet class="c-block-1">
          <secondary-table-component
            :showSelect="false"
            itemKey="id"
            :headers="managerHeaders"
            :pagination="this.$store.state.pagination"
            :limit="$store.state.counterOfShow"
            :items="tableData"
            :loading="loading"
          >
            <template slot="item.incoming_count" slot-scope="props">
              <v-chip small color="blue lighten-5" text-color="blue darken-2">
                {{ formatCount(props.item.incoming_count) }}
              </v-chip>
            </template>
            <template slot="item.outgoing_count" slot-scope="props">
              <v-chip small color="purple lighten-5" text-color="purple darken-2">
                {{ formatCount(props.item.outgoing_count) }}
              </v-chip>
            </template>
            <template slot="item.unknown_count" slot-scope="props">
              <v-chip small color="grey lighten-5" text-color="grey darken-2">
                {{ formatCount(props.item.unknown_count) }}
              </v-chip>
            </template>
            <template slot="item.total_count" slot-scope="props">
              <strong>{{ formatCount(props.item.total_count) }}</strong>
            </template>
          </secondary-table-component>
        </v-sheet>
      </v-col>
    </v-row>
    <br />
    <!-- ====================================================================================================================== -->
    <v-sheet class="c-block-1">
      <v-row>
        <v-col cols="12">
          <h4 class="sub-title">الاستشاريين</h4>
        </v-col>
        <v-col cols="12" class="sales-managers-ch">
          <v-row>
            <v-col v-for="(item, index) in itemsSalesManagers" :key="index" cols="2">
              <v-radio-group v-model="selected_sales_manger">
                <v-radio :label="item.label" :value="item.value"></v-radio>
              </v-radio-group>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="12">
          <CallCenterChart
            :xaxis="xaxis"
            :incomingData="incomingChartData"
            :outgoingData="outgoingChartData"
            :unknownData="unknownChartData"
          />
        </v-col>
      </v-row>
    </v-sheet>
    <br />
    <!-- ====================================================================================================================== -->
    <v-sheet class="c-block-1">
      <v-row class="align-center px-3 pt-3">
        <v-col cols="12" sm="4">
          <h4 class="sub-title mb-0">تفاصيل المكالمات</h4>
        </v-col>
        <v-col cols="12" sm="4">
          <v-select
            v-model="callTypeFilter"
            :items="callTypeOptions"
            item-text="label"
            item-value="value"
            label="نوع المكالمة"
            dense
            outlined
            hide-details
            @change="fetchCallsList(1)"
          ></v-select>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <secondary-table-component
            :showSelect="false"
            itemKey="id"
            :headers="callsHeaders"
            :pagination="{ count: callsPagination.total || 0 }"
            :limit="callsPerPage"
            :items="callsList"
            :loading="callsLoading"
            :value="callsPage"
            @input="fetchCallsList"
          >
            <template slot="item.call_type" slot-scope="props">
              <v-chip
                small
                :color="props.item.call_type_key === 'incoming' ? 'blue lighten-5' : 'purple lighten-5'"
                :text-color="props.item.call_type_key === 'incoming' ? 'blue darken-2' : 'purple darken-2'"
              >
                {{ props.item.call_type }}
              </v-chip>
            </template>
            <template slot="item.request_id" slot-scope="props">
              <span v-if="props.item.request_id">#{{ props.item.request_id }}</span>
              <span v-else>—</span>
            </template>
          </secondary-table-component>
        </v-col>
      </v-row>
    </v-sheet>
  </div>
</template>

<script>
import { axiosInstance } from "@/axios/config";
import RateFilter from "./RateFilter";
import CallCenterChart from "./CallCenterChart";
import router from "@/routes";

export default {
  components: {
    CallCenterChart,
    RateFilter,
  },
  data() {
    return {
      query_params_obj: {},
      loading: true,
      callsLoading: false,
      xaxis: [],
      incomingChartData: [],
      outgoingChartData: [],
      unknownChartData: [],
      selected_sales_manger: "",
      incoming_count: null,
      outgoing_count: null,
      unknown_count: null,
      total_count: null,
      incoming_percent: 0,
      outgoing_percent: 0,
      callTypeFilter: "",
      callTypeOptions: [
        { label: "الكل", value: "" },
        { label: "واردة", value: "incoming" },
        { label: "صادرة", value: "outgoing" },
      ],
      callsList: [],
      callsPagination: { total: 0 },
      callsPage: 1,
      callsPerPage: 15,
      itemsSalesManagers: [{ label: "جميع الاستشاريين", value: "" }],
      managerHeaders: [
        { text: "مدير المبيعات", value: "name", align: "center", width: "35%" },
        { text: "واردة", value: "incoming_count", align: "center" },
        { text: "صادرة", value: "outgoing_count", align: "center" },
        { text: "غير معروف", value: "unknown_count", align: "center" },
        { text: "الإجمالي", value: "total_count", align: "center" },
      ],
      callsHeaders: [
        { text: "الاستشاري", value: "agent_name", align: "center" },
        { text: "النوع", value: "call_type", align: "center" },
        { text: "المدة", value: "duration", align: "center" },
        { text: "التاريخ", value: "day_date", align: "center" },
        { text: "الطلب", value: "request_id", align: "center" },
      ],
      tableData: [],
    };
  },
  watch: {
    selected_sales_manger() {
      this.getAgentsCallCenter();
      this.fetchCallsList(1);
    },
  },
  methods: {
    backToAgentPercentage() {
      router.push({ name: "agent-percentage" });
    },
    formatCount(val) {
      if (val === null || val === undefined) return "—";
      return Number(val).toLocaleString("ar-EG");
    },
    getCallCenterStats() {
      axiosInstance
        .get(`/employee/admin/call-center-statistics`, { params: this.query_params_obj })
        .then((res) => {
          this.incoming_count   = res.data.payload.incoming_count;
          this.outgoing_count   = res.data.payload.outgoing_count;
          this.unknown_count    = res.data.payload.unknown_count;
          this.total_count      = res.data.payload.total_count;
          this.incoming_percent = res.data.payload.incoming_percent;
          this.outgoing_percent = res.data.payload.outgoing_percent;
        })
        .catch(() => {});
    },
    getSalesCallCenter() {
      axiosInstance
        .get(`/employee/admin/call-center-statistics-salesmanagers`, { params: this.query_params_obj })
        .then((res) => {
          this.tableData = res.data.payload;
          this.itemsSalesManagers = [{ label: "جميع الاستشاريين", value: "" }];
          res.data.payload.forEach((element) => {
            this.itemsSalesManagers.push({
              label: element.name,
              value: element.id,
            });
          });
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getAgentsCallCenter() {
      let params = { ...this.query_params_obj };
      if (this.selected_sales_manger !== "") {
        params.sales_manger_id = this.selected_sales_manger;
      }
      this.xaxis = [];
      this.incomingChartData = [];
      this.outgoingChartData = [];
      this.unknownChartData = [];
      axiosInstance
        .get(`/employee/admin/call-center-statistics-salesmanagers-agents`, { params })
        .then((res) => {
          res.data.payload.forEach((element) => {
            this.xaxis.push(element.name);
            this.incomingChartData.push(element.incoming_count);
            this.outgoingChartData.push(element.outgoing_count);
            this.unknownChartData.push(element.unknown_count);
          });
        })
        .catch(() => {});
    },
    fetchCallsList(page) {
      this.callsLoading = true;
      const pageNum = page || this.callsPage || 1;
      this.callsPage = pageNum;
      let params = {
        ...this.query_params_obj,
        page: pageNum,
        per_page: this.callsPerPage,
      };
      if (this.callTypeFilter) {
        params.type = this.callTypeFilter;
      }
      if (this.selected_sales_manger !== "") {
        params.sales_manger_id = this.selected_sales_manger;
      }
      axiosInstance
        .get(`/employee/admin/call-center-calls-list`, { params })
        .then((res) => {
          const payload = res.data.payload;
          this.callsList = payload.data || [];
          this.callsPagination = { total: payload.total || 0 };
          this.callsLoading = false;
        })
        .catch(() => {
          this.callsLoading = false;
        });
    },
    handleFilter(obj) {
      this.query_params_obj.from_date = obj.startDate;
      this.query_params_obj.to_date = obj.endDate;
      this.getCallCenterStats();
      this.getSalesCallCenter();
      this.getAgentsCallCenter();
      this.fetchCallsList(1);
    },
  },
  created() {
    this.getCallCenterStats();
    this.getSalesCallCenter();
    this.getAgentsCallCenter();
    this.fetchCallsList(1);
  },
};
</script>

<style scoped>
h4.sub-title {
  background-color: #d9d1da;
  padding: 11px 11px;
  margin: 11px 0px;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border-bottom: 1px solid;
  color: #451646;
}
.call-center-summary {
  text-align: center;
  padding: 16px !important;
}
.call-stats-grid {
  display: flex;
  align-items: stretch;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 12px;
}
.call-stat-box {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 10px 6px;
  border-radius: 8px;
  min-height: 80px;
}
.call-stat-box.incoming {
  background: rgba(21, 101, 192, 0.08);
}
.call-stat-box.outgoing {
  background: rgba(126, 18, 128, 0.08);
}
.call-stat-box.total {
  background: rgba(63, 14, 64, 0.06);
  border: 1px solid rgba(63, 14, 64, 0.15);
}
.call-stat-num {
  font-size: 1.3rem;
  font-weight: 700;
  color: #333;
  line-height: 1.2;
  margin-top: 4px;
}
.call-stat-num-lg {
  font-size: 1.75rem;
  font-weight: 800;
  color: #3f0e40;
  line-height: 1.2;
}
.call-stat-lbl {
  font-size: 0.75rem;
  color: #666;
  margin-top: 2px;
}
.call-ratio-bar {
  display: flex;
  height: 10px;
  border-radius: 5px;
  overflow: hidden;
  background: #eee;
}
.call-ratio-seg {
  height: 100%;
  transition: width 0.4s ease;
}
.incoming-seg {
  background: linear-gradient(90deg, #1565c0, #42a5f5);
}
.outgoing-seg {
  background: linear-gradient(90deg, #7e1280, #ab47bc);
}
.back-txt {
  cursor: pointer;
}
</style>
